export default "__VITE_ASSET__M5lR5NIU__"